
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { QuotePlaybackRiskWarning } from '../../model/ngrx/playback-risk-warnings.model';

export const ADD_QUOTE_PLAYBACK_RISK_WARNING = '[QuotePlaybackRiskWarning] Add';
export const REMOVE_QUOTE_PLAYBACK_RISK_WARNING = '[QuotePlaybackRiskWarning] Remove';


export class AddQuotePlaybackRiskWarning implements Action {
    readonly type = ADD_QUOTE_PLAYBACK_RISK_WARNING;

    constructor(public payload: QuotePlaybackRiskWarning) { }
}

export class RemoveQuotePlaybackRiskWarning implements Action {
    readonly type = REMOVE_QUOTE_PLAYBACK_RISK_WARNING;

    constructor(public payload: number) { }
}

export type Actions = AddQuotePlaybackRiskWarning | RemoveQuotePlaybackRiskWarning;
